export default {
  GET_STATE (state, details) {
    localStorage.setItem('user_name', details.data[0].full_name)
    localStorage.setItem('lkjhgfdsa', details.data[0].public_id)
    state.session = details.data[0]
  }
}
